// Rendering last searches on the main page if template exists and 3 or more searches are stored
function setupTyreLastSearches() {
    if ($('.tyre-last-searches-container').length) {
        var lastSearches = JSON.parse(localStorage.getItem('tyreLastSearches'))
        if (!lastSearches) {
            localStorage.setItem('tyreLastSearches', JSON.stringify([]))
            return
        }
        if (lastSearches.length < 3) {
            return
        }

        searchesHTML = ""
        lastSearches.forEach(searchLink => {
            search = parseTyreSearchLink(searchLink)
            searchesHTML += '<div class="tyre-last-search-single-item">'
                          + '<a href="' + searchLink + '">'
                          + '<span>'
                          + getSearchTitle(search, searchLink)
                          + '<br>'
                          + getDisplayedParams(search)
                          + '</span>'
                          + '</a>'
                          + '</div>'
        })
        $('.tyre-last-search-row-items').append(searchesHTML)

        $('.tyre-last-searches-container').attr('hidden', false);
    }
}

// Checks if there link with the same displayed params and removes stored one if present
// New search appends to the beginning of the stored array
// Only 6 last searches can be stored
function saveTyreLastSearch(searchLink) {
    if ($('#isEnableTyreLastSearches').val() !== 'true') {
        return
    }

    var search = parseTyreSearchLink(searchLink)
    if (isForSave(search, searchLink)) {
         var lastSearches = JSON.parse(localStorage.getItem('tyreLastSearches'))
         if (!lastSearches) {
              lastSearches = []
         }
         lastSearches = lastSearches.filter(storedSearchLink =>
             !isSearchEqualsByPredefinedParams(search, storedSearchLink)
         )
         lastSearches = [searchLink].concat(lastSearches)
         lastSearches = lastSearches.slice(0, 6)
         localStorage.setItem('tyreLastSearches', JSON.stringify(lastSearches))
    }
}

// Processing title of the particular search
function getSearchTitle(search, searchLink) {
    if (search.vehicleTypes === 'MO') {
        return $('#motoTitle')[0].defaultValue
    }

    var title
    if (search.season) {
        if (search.season === 'spikes') {
            return $('#spikesTitle')[0].defaultValue
        }

        seasonNameAcc = 'season'
                      + search.season.slice(0, 1).toUpperCase()
                      + search.season.slice(1).toLowerCase()
        title = ACC[seasonNameAcc]

        if (!title && isCustomLink(searchLink)) {
            title = search.season + " " + $('#defaultSearchTitle')[0].defaultValue.split(" ")[1]
        }
    }
    if (!title) {
        title = $('#defaultSearchTitle')[0].defaultValue
    }
    return title
}

// Processing params of the particular search
function getDisplayedParams(search) {
    var paramsLine = ''
    if (search.width) {
        paramsLine += decodeURIComponent(search.width)
    }
    if (search.profile) {
        if (search.width) {
            paramsLine += '/'
        }
        paramsLine += search.profile
    }
    if (search.size) {
        paramsLine += ' R' + search.size
    }
    if (search.loadIndex || search.speedRating) {
        paramsLine += ' '
        if (search.loadIndex) {
            paramsLine += search.loadIndex
        }
        if (search.speedRating) {
            paramsLine += search.speedRating
        }
    }
    return paramsLine
}

// Parsing string tyre search link to search object
function parseTyreSearchLink(searchLink) {
    if (isCustomLink(searchLink)) {
        return parseTyreSearchCustomLink(searchLink)
    }

    search = {}
    firstParamPosition = searchLink.indexOf('?') + 1
    searchLink.slice(firstParamPosition)
                 .split('&').forEach(paramLine => {

        delimiterPosition = paramLine.indexOf('=')
        key = paramLine.slice(0, delimiterPosition)
        value = paramLine.slice(delimiterPosition + 1)

        processAndSetupField(search, key, value)
    })

    if (search.season) {
        search.season = search.season.toLowerCase()
    }

    return search
}

function parseTyreSearchCustomLink(searchLink) {
    linkItems = searchLink.split("/")
    paramsLine = linkItems.at(-1)

    seasonPosition = -2
    if (parseFloat(linkItems.at(seasonPosition))) {
        paramsLine = linkItems.at(seasonPosition) + "/" + paramsLine
        seasonPosition -= 1
    }

    search = {}
    search.season = linkItems.at(seasonPosition)

    params = paramsLine.split("-")
    search.width = params[0]
    search.profile = params[1]
    search.size = params[2].replace("R", "")
    search.speedRating = params[3]

    return search
}

function processAndSetupField(search, key, value) {
    if (!value) {
        return
    }

    if (!search[key]) {
        search[key] = value
    } else if (key = 'vehicleTypes') {
        search[key] = [value].concat(search[key])
    }
}

function isForSave(search, searchLink) {
    if ((!search.width && !search.profile && !search.size && !search.loadIndex && !search.speedRating)
        || search.vehicleId) {
        return false
    }

    return true;
}

function isSearchEqualsByPredefinedParams(currentSearch, storedSearchLink) {
    return isSearchEquals(currentSearch,
                          parseTyreSearchLink(storedSearchLink))
}

function isSearchEquals(currentSearch, storedSearch) {
    return storedSearch.width === currentSearch.width
           && storedSearch.profile === currentSearch.profile
           && storedSearch.size === currentSearch.size
           && storedSearch.season === currentSearch.season
           && storedSearch.loadIndex === currentSearch.loadIndex
           && storedSearch.speedRating === currentSearch.speedRating
}

// Defines urls like '/rshop/Winter/205-70-R16-Q'
function isCustomLink(link) {
    return !link.includes("?") &&  link.match(new RegExp("/.+-.+-.+-.+$", "g"))
}